<template>
  <app>
    <template v-slot:languageSelection>
      <language-selection />
    </template>
    <template v-slot:content>
      <contact />
    </template>
  </app>
</template>

<script>
const App = () => import(/* webpackChunkName: "ContactPage" */ "@/App.vue");
const LanguageSelection = () =>
  import(/* webpackChunkName: "ContactPage" */ "@/components/Global/LanguageSelection.vue");
const Contact = () => import(/* webpackChunkName: "ContactPage" */ "@/views/Contact.vue");

export default {
  name: "ContactApp",
  components: {
    App,
    LanguageSelection,
    Contact
  }
};
</script>
